/**
 * Действие строительства этого хода, которое снимает двойной клик по ячейке:
 * ПОСЛЕДНЕЕ в этой ячейке (постройка или ремонт). Именно последнее — действия
 * одной ячейки лежат друг на друге: крепость на квартале этого же хода
 * снимается раньше квартала, иначе отмена квартала снесла бы и ее.
 *
 * Зафиксированное действие (isCommited — после разведки шахты гномами) не
 * отменяется ничем; фиксируется всё построенное к тому моменту разом, так что
 * если зафиксировано последнее действие ячейки, отменять в ней нечего.
 */
export const findHexUndoableConstruction = (pendingBuildings, hexKey) => {
  const lastOnHex = (pendingBuildings || []).findLast((building) => building.hexKey === hexKey);
  return lastOnHex && !lastOnHex.isCommited ? lastOnHex : null;
};
